var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ComponentBase } from "./ComponentBase";
import { tgfSettings } from "../tgfSettings";
import { tbVectorFont } from "../../engine/tbVectorFont";
import { s_tgf_transparent } from "../../code/AssetDefinitions/ImageDefinitions";
tgfSettings.componentDefaults.spineComponent = {
    spineAnimation: undefined,
    spineClone: undefined,
    animationClip: "animation",
    delay: -1,
    scale: 1,
    repeat: false,
    onComplete: null,
    onEvent: null,
    play: true,
    hasDelay: true,
    flip: false,
    skin: null,
    imagesToSlots: [],
    labelsToSlots: [],
    imageToSlotRotation: Math.PI,
    flipImagesToSlot: true,
    components: [] // Components to add as children
};
var ComponentSpine = /** @class */ (function (_super) {
    __extends(ComponentSpine, _super);
    function ComponentSpine(properties) {
        var _this = _super.call(this) || this;
        _this.flipImagesToSlot = false;
        _this.name = "SpineComponent";
        // Initialize properties
        _this.initialize(tgfSettings.componentDefaults.spineComponent);
        // Set user properties
        if (properties !== undefined) {
            _this.setProperties(properties);
        }
        return _this;
    }
    ComponentSpine.prototype.setSkin = function (skin) {
        var _a;
        this.skin = skin;
        (_a = this.spineClone) === null || _a === void 0 ? void 0 : _a.setSkin(this.skin);
    };
    ComponentSpine.prototype.setAnimation = function (animation, onComplete) {
        if (this.spineClone) {
            this.spineClone.setAnimation(animation, this.repeat);
            this.spineClone.setOnComplete(function () {
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            });
        }
    };
    ComponentSpine.prototype.setAlpha = function (alpha) {
        var _a;
        (_a = this.spineClone) === null || _a === void 0 ? void 0 : _a.setAlpha(alpha);
    };
    ComponentSpine.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
        this.spineClone.setPosition(this.containerRelativeX(), this.containerRelativeY());
    };
    ComponentSpine.prototype.bringToFront = function () {
        this.baseContainer.removeChild(this.spineClone);
        this.baseContainer.addChild(this.spineClone);
    };
    ComponentSpine.prototype._setAnimation = function () {
        var _this = this;
        this.spineClone.setAnimation(this.animationClip, this.repeat);
        this.spineClone.setOnComplete(function () {
            var _a;
            (_a = _this.onComplete) === null || _a === void 0 ? void 0 : _a.call(_this);
        });
    };
    ComponentSpine.prototype.setEvent = function (event) {
        this.spineClone.setEventCallback(event, this._onEventCallback, this);
    };
    ComponentSpine.prototype.clearEvents = function () {
        this.spineClone.clearAllEventCallbacks();
    };
    ComponentSpine.prototype.unPause = function () {
        this._setAnimation();
    };
    ComponentSpine.prototype.getSlot = function (slotIndex) {
        return this.spineClone.animation.slotContainers[slotIndex];
    };
    ComponentSpine.prototype._addFontToSlot = function (slotIndex, font) {
        var image = s_tgf_transparent.clone();
        image.addChild(font);
        var slot = this.getSlot(slotIndex);
        slot.addChild(image.sprite);
        image.setRotation(this.imageToSlotRotation);
        if (this.flipImagesToSlot) {
            image.setScale(-1, 1);
        }
    };
    ComponentSpine.prototype.addLabelToSlot = function (slotIndex, label) {
        this.labelsToSlots.push({
            slotIndex: slotIndex,
            label: label
        });
        if (this.spineClone) {
            var font = void 0;
            if (!(label.font instanceof tbVectorFont)) {
                font = new tbVectorFont();
                font.setProperties(label.font);
                font.setText(label.text);
                font.setPosition(label.x, label.y);
            }
            else {
                font = label.font;
            }
            this._addFontToSlot(slotIndex, font);
        }
    };
    ComponentSpine.prototype.addImageToSlot = function (slotIndex, image) {
        this.imagesToSlots.push({
            slotIndex: slotIndex,
            image: image
        });
        if (this.spineClone) {
            var slot = this.getSlot(slotIndex);
            var clone = image.clone();
            slot.addChild(clone.sprite);
            clone.setRotation(this.imageToSlotRotation);
            clone.setTint(image.tint ? image.tint : 0xFFFFFF);
            clone.setScale(image.scaleX, image.scaleY);
            clone.setPosition(image.x, image.y);
            if (this.flipImagesToSlot) {
                clone.setScale(clone.scaleX * -1, clone.scaleY * 1);
            }
        }
    };
    ComponentSpine.prototype.removeImageInSlot = function (slotIndex, image) {
        var indexToRemove = [];
        for (var i = 0; i < this.imagesToSlots.length; i += 1) {
            if (this.imagesToSlots[i].slotIndex !== slotIndex) {
                continue;
            }
            if (this.imagesToSlots[i].image.name !== image.name) {
                continue;
            }
            indexToRemove.push(i);
            if (this.spineClone) {
                var slot = this.getSlot(this.imagesToSlots[i].slotIndex);
                slot.removeChild(this.imagesToSlots[i].image);
            }
        }
        for (var i = 0; i < indexToRemove.length; i += 1) {
            this.imagesToSlots.splice(indexToRemove[i], 1);
        }
    };
    // ***************************************
    // Preparing, showing and activating
    //      - These can be removed if no processing is required
    // ***************************************
    // Processing required when preparing the component for use
    ComponentSpine.prototype.doPrepare = function () {
        if (this.play && this.delay > 0) {
            this.delay = -1;
        }
        this.spineClone = this.spineAnimation.clone();
        this._setAnimation();
        this.setPosition(this.x, this.y);
        this.baseContainer.addChild(this.spineClone);
        this.spineClone.setAlpha(this.alpha);
        this.spineClone.setScale(this.scale);
        if (this.skin) {
            this.spineClone.setSkin(this.skin);
        }
        if (this.imagesToSlots) {
            for (var i = 0; i < this.imagesToSlots.length; i += 1) {
                var image = this.imagesToSlots[i].image;
                var clone = image.clone();
                var slot = this.getSlot(this.imagesToSlots[i].slotIndex);
                slot.addChild(clone.sprite);
                clone.setRotation(this.imageToSlotRotation);
                clone.setTint(image.tint ? image.tint : 0xFFFFFF);
                clone.setScale(image.scaleX, image.scaleY);
                clone.setPosition(image.x, image.y);
                if (this.flipImagesToSlot) {
                    clone.setScale(clone.scaleX * -1, clone.scaleY * 1);
                }
            }
        }
        if (this.labelsToSlots) {
            for (var i = 0; i < this.labelsToSlots.length; i += 1) {
                var label = this.labelsToSlots[i].label;
                var font = void 0;
                if (!(label.font instanceof tbVectorFont)) {
                    font = new tbVectorFont();
                    font.setProperties(label.font);
                    font.setText(label.text);
                    font.setPosition(label.x, label.y);
                }
                else {
                    font = label.font;
                }
                this._addFontToSlot(this.labelsToSlots[i].slotIndex, font);
            }
        }
        if (this.flip) {
            this.spineClone.flip();
        }
        // Add the child components
        if (this.components) {
            for (var i = 0; i < this.components.length; i += 1) {
                this.addComponent(this.components[i]);
            }
        }
    };
    // Processing required when freeing the component from use
    ComponentSpine.prototype.doFree = function () {
        if (this.spineClone) {
            this.spineClone.remove(this.baseContainer);
            this.spineClone.free();
            this.spineClone = null;
        }
    };
    // Processing required when showing the component
    ComponentSpine.prototype.doShow = function () {
        this.spineClone.show();
    };
    // Processing required when hiding the component
    ComponentSpine.prototype.doHide = function () {
        // this.baseContainer.removeChild(this.spineClone);
        this.spineClone.hide();
    };
    ComponentSpine.prototype.remove = function () {
        this.baseContainer.removeChild(this.spineClone);
    };
    ComponentSpine.prototype.add = function () {
        this.baseContainer.addChild(this.spineClone);
    };
    // ***************************************
    // Methods called when events must be processed
    //      - These can be removed when no processing is required
    //      - When they return true, this event is no further processed
    //          by other components in the dialog
    //      - Never call these methods yourself in other components,
    //          Use the inherited handle methods instead
    // ***************************************
    // Called at the beginning of each step
    ComponentSpine.prototype.doBeginStep = function (timePassed) {
        var _a;
        if (!this.hasDelay || this.delay > 0) {
            this.delay -= timePassed;
            return;
        }
        this.play = true;
        if (this.onEventFireDelay >= 0) {
            this.onEventFireDelay -= timePassed;
            if (this.onEventFireDelay < 0) {
                this.onEventFireDelay = -69;
                (_a = this.onEvent) === null || _a === void 0 ? void 0 : _a.call(this);
                this.onEvent = undefined;
            }
        }
    };
    // Called after drawing the sub-components
    ComponentSpine.prototype._onEventCallback = function () {
        this.onEventFireDelay = 100; // ms
    };
    return ComponentSpine;
}(ComponentBase));
export { ComponentSpine };
